import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { preloadAndCacheImage } from '../utils/imageCacheUtils';
import { getLocalizedText } from '../utils/textLocalization';
import EditableField from '../editry/EditableField';

// Cache key for novinky images
const NOVINKY_CACHE_KEY = 'ridleyNovinkyImages';

// A component to render a novinka item
const NovinkyItem = ({ novinka, index, ridleyImage }) => {
  // Get localized text
  const showButtonText = getLocalizedText('general.show_button');
  
  // Helper function to safely extract string values from Builder.io content
  const safeString = (value, fallback = '') => {
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && value !== null) {
      // Handle Builder.io rich text objects
      if (value.Default) return value.Default;
      if (value['@type'] === 'string' && value.value) return value.value;
      // Try to extract text content if it's a complex object
      if (value.text) return value.text;
      if (value.content) return value.content;
    }
    return fallback;
  };

  const imageUrl = novinka.data?.image || ridleyImage;
  const route = novinka.data?.route || '#';
  
  // Use effect to preload and cache the image
  useEffect(() => {
    // Preload and cache the image
    const preloadImage = async () => {
      await preloadAndCacheImage(imageUrl, NOVINKY_CACHE_KEY, ridleyImage);
    };
    
    preloadImage();
    
    return () => {
      // Cleanup if needed
    };
  }, [imageUrl, ridleyImage]);
  
  return (
    <NavLink to={`/article/${route}`}>
      <div className="novinky-box">
        <div>
          <EditableField model="novinky" item={novinka} field="image" as="img" className="editry-fill-image">
            <img
              src={imageUrl}
              alt="Ridley novinky"
              onError={(e) => {
                console.warn("Image failed to load, using fallback");
                e.target.src = ridleyImage;
              }}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }}
            />
          </EditableField>
          <span>
            <EditableField model="novinky" item={novinka} field="tag">
              {safeString(novinka.data?.tag, 'Novinky')}
            </EditableField>
          </span>
        </div>
        <button><span>{showButtonText}</span></button>
        <h2>
          <EditableField model="novinky" item={novinka} field="title">
            {safeString(novinka.data?.title, 'Článek')}
          </EditableField>
        </h2>
        <p>
          <EditableField model="novinky" item={novinka} field="description">
            {novinka.data?.description ?
              safeString(novinka.data.description, 'Popis článku...').replace(/<[^>]*>/g, '').substring(0, 100) + '...' :
              'Popis článku...'}
          </EditableField>
        </p>
      </div>
    </NavLink>
  );
};

export default NovinkyItem;
